import { createSelector } from "reselect";

const currentConversastionUserSelector = (state: TReduxState) =>
  state.features.conversationUser;

export const getConversationUser = createSelector(
  currentConversastionUserSelector,
  (currentUser) => currentUser.user
);
